import styled from 'styled-components'
import { theme, media } from '../../../../../styles/_variables'

export const FullWidthContainer = styled.div`
  width: 100%;
  margin-left: 0%;
  justify-content: center;
`

export const ContentParts = styled.div`
  max-width: 100%;
  width: 100%;
`

export const SummaryDiv = styled.div`
  width: 100%;
  margin-left: 12px;
`


export default FullWidthContainer



// WEBPACK FOOTER //
// ./src/pages/package-page/detail/components/parts/styled.js